import appLocaleData from 'react-intl/locale-data/en';
/* import enMessages from '../locales/en_US'; */

const EnLang = {
    messages: {
        /* ...enMessages */
         /* next */
    "next": "Next",

    /* 01.General */
    "navbarHome.login": "Login",
    "navbarHome.logout": "Log out",
    "navbarHome.profile": "Profile",
    "navbarHome.register": "Register",
    "navbarHome.email": "Email",
    "navbarHome.ex_email": "Email (Example@mail.com)",
    "navbarHome.password": "Password",
    "navbarHome.validationInformation": "Please complete the information",
    "navbarHome.validationEmail": "Please check that your email and password are correct.",
    "navbarHome.validationEmail": "Please check that your email and password are correct.",
    "navbarHome.forgotpassword": "Forgot password",
    "navbarHome.donAccount": "Don't have an account?",
    "navbarHome.createAccount": "Sign Up",
    "navbarHome.exerciseprogram": "Exercise Program",
    "navbarHome.foodsupplements": "How to eat food and supplements",
    "navbarHome.admin": "Admin",
    /* 02.programPackage */
    "programPackage.registerBebeStayfit": "Sign up for Bebe Stayfit",
    "programPackage.calculate": "Please fill in the information to calculate how long it takes to lose weight.",
    "programPackage.loseWeight": "How to lose weight",
    "programPackage.convenientLoseWeight": "What's the most convenient way to lose weight?",
    "programPackage.dietAndExercise": "Diet and exercise",
    "programPackage.onlydiet": "Only diet",
    "programPackage.selectUnit": "Select Unit",
    "programPackage.pound": "Pound",
    "programPackage.kilogram": "Kilogram",
    "programPackage.manyKilograms": "How many kilograms do you want to lose weight?",
    "programPackage.ableLose": "You will be able to lose",
    "programPackage.kgIn": "in",
    "programPackage.months": "months",
    "programPackage.choosePackage": "Please choose your package",
    "programPackage.beginner": "Beginner gets fit",
    "programPackage.price": "Price",
    "programPackage.baht": "Baht",
    "programPackage.2months": "2 months and no renewal",
    "programPackage.regular": "Regular price for 2 months program",
    "programPackage.exercise": "Exercise Program",
    "programPackage.dietary": "Dietary Suggestion",
    "programPackage.foodSupplement": "Food supplement suggestion",
    "programPackage.fittoPlant": "Fitto Plant Protein 6 boxes",
    "programPackage.chooseFlavor": "Choose any flavor",
    "programPackage.saveMore": "Save more !!",
    "programPackage.applyProgram": "Subscribtion",
    "programPackage.specialPrice": "(Special price for the first 2 months. When the maturity is due, will be paid on amonthly basis, (1,800 baht per month) until the end of the period recommended by the program. **You can pause your monthly payments whenever you want.)",
    "programPackage.specialPriceFirst": "Special price for the first 2 months",
    "programPackage.auto-renewal": "Auto-renewal for the duration of the program.",
    "programPackage.6boxes/2Month": "Fitto plant Protein 6boxes/2 months",
    "programPackage.1month3boxes": "1 month for 3 boxes",
    "programPackage.free": "Free",
    "programPackage.select": "Select",
    "programPackage.resultsObtained": "The results obtained are statistical values. It may change depending on individual conditions.",
    "programPackage.firstonly": "first purchase only",
    "programPackage.shaker": "Free Shaker 1 piece",
    "programPackage.greenLemonade": " Green Lemonade  1 pack",
    "programPackage.arabicaLatte": "รส Arabica Latte  1 pack",
    "programPackage.collaC": " 1 pack",

    /* 03.register */
    "register.chooseYouPackage": "Choose your package",
    "register.chooseYouAccount": "Creatc your account",
    "register.chooseYouflavor": "Choose the flavor of the supplement",
    "register.deliveryAddress": "delivery address",
    "register.payment": "Payment",
    "register.confirmPassword": "Confirm your password",
    "register.phoneNumber": "Phone Number",
    "register.displayname": "ชื่อที่ใช้แสดงในระบบ",
    "register.createAccount": "Create your account",
     "register.accountCredited": "An account for",
     "register.passwordsnotMatch": "invalid password please try again ",
     "register.passwordtooShort": "Password is too short",
     "register.numberCharacters": "Password must be at least 6 characters",
 
     "register.ex.phone": "example 08XXXXXXXX",
    
    /* 04. fitto_plant_protein */
    "fitto_plant_protein.chooseProtein": "Choose the flavor of the supplement of Fitto Plant Protein",
    "fitto_plant_protein.youAreApplying": "If you are applying for",
    "fitto_plant_protein.theDuration": "the duration of the program",
    "fitto_plant_protein.willBe": "will be able to change the taste later",
    "fitto_plant_protein.box1": "Box 1",
    "fitto_plant_protein.box2": "Box 2",
    "fitto_plant_protein.box3": "Box 3",
    "fitto_plant_protein.box4": "Box 4",
    "fitto_plant_protein.box5": "Box 5",
    "fitto_plant_protein.box6": "Box 6",

    /* 05.shipping_address */
    "shipping_address.shippingAddress": "Shipping address",
    "shipping_address.name": "Name",
    "shipping_address.surname": "Surname",
    "shipping_address.address": "Address",
    "shipping_address.subdistrict": "Subdistrict",
    "shipping_address.district": "District",
    "shipping_address.province": "Province",
    "shipping_address.postcode": "Postcode",
    "shipping_address.taxinvoice": "Request a receipt and tax invoice",
    "shipping_address.addressInvoice": "Address for a receipt and tax invoice",
    "shipping_address.individual": "Individual",
    "shipping_address.juristic": "juristic person",
    "shipping_address.taxpayer": "Taxpayer Name",
    "shipping_address.nameJuristic": "Name of / juristic persone",
    "shipping_address.office": "Head Office/Branch",
    "shipping_address.phoneNumber": "Phone Number",
    "shipping_address.identification": "Tax Identification Number",
    "shipping_address.sameAddress": "Same address for shipping",
    "shipping_address.cancel": "Cancel",
    "shipping_address.confirm": "Confirm",

    /* 06.payment */
    "payment.payment": "Payment",
    "payment.credit": "Credit/Debit",
    "payment.qrcode": "Pay by QR Code",
    "payment.cardNumber": "16 digit card number",
    "payment.errorBilling": "Payment verification failed please verify your card information or change the payment method",
    "payment.nameCard": "Name on card",
    "payment.expirationDate": "Expiration date",
    "payment.cvv": "CVV Code",
    "payment.yourPackage": "Your package",
    "payment.applyProgram": "Apply for the duration of the program",
    "payment.baht2months": "3750 Baht / 2 months",
    "payment.collectPayment": "We will collect payment every 2 months.",
    "payment.pay": "Pay",
    "payment.messagQrcode1": "1. After click “Pay” button. You'll receive a QR Code to pay",
    "payment.messagQrcode2": "2. Please open your bank application",
    "payment.messagQrcode3": "3. Click on “scan” or “pay”",
    "payment.messagQrcode4": "4. Please verify the information before making a transaction",


    /* 07.welcome_new_member */
    "welcome_new_member.welcome": "welcome our new member",
    "welcome_new_member.thankYou": "Thank you for applying to be a member of Bebe Stay Fit. Our team has received the application information already. We thank you for your interest and for choosing us to be a part of high success. Let's create discipline and have fun with exercise.",
    "welcome_new_member.getStart": "Get start",
    "welcome_new_member.incorrectPassword": "Incorrect Password",
    "welcome_new_member.backtohome": "Back to Homepage",
    "welcome_new_member.clickLogin": "Click 'Log in'",

    /* 08.reset_password */
     "reset_password.forgetPassword": "Forget Password",
     "reset_password.yourEmail": "Please enter your email, you will receive a link to create a new password via email.",
      "reset_password.pleasecheck": "Please check your Email: ",
      "reset_password.afresh": "Try again",

     /* 09.reset_password_succeed */
     "reset_password_succeed.newpassword": "We have sent you a link to create a new password via  email. If you can't find the email, please check your spam folder",
     "reset_password_succeed.orcontact": "or contact us 086 424 5141",
     "reset_password_succeed.from": "(from 6:00 AM to 6:00 PM.)",
     "reset_password_succeed.backtomain": "Back to Main Page",

     /* 10.videoList */
     "videoList.challenge": "Challenge",
     "videoList.total": "total training period",
     "videoList.mins": "mins",
    "videoList.autoPlay": "Auto-play",
     "videoList.letsStart": "Let's Start!",
     "videoList.succeed": "Done!",
     "videoList.currentweight": "Please enter your current weight",
     "videoList.off": "Off",
     "videoList.enterweekly": "Please enter weekly so that you can be guided correctly",
     "videoList.checkinformation": "Please verify the information again so that we can provide accurate information",
     "videoList.programjust": "An exercise program that designed specifically for you",
     "videoList.weight": "weight (kg)",
     "videoList.height": "height (cm.)",
     "videoList.pleasefill": "Please fill in the required information",
     "videoList.mustnot": "Please enter your age, Don't use decimal numbers",
     "videoList.measureyour": "Please measure your sizes",
     "videoList.usingsample": "By using our sizing guide to help you measure correctly",
     "videoList.chest": "Chest (Inches)",
     "videoList.waistline": "Waist (Inches)",
     "videoList.hip": "Hip (Inches)",
     "videoList.goback": "Back",
     "videoList.particulars": "Summarize",
     "videoList.exerciseaccording": "How to exercise according to the program",
     "videoList.workout": "Workout Routine",

     /* 11.profile */
     "profile.editInformation": "Edit information",
     "profile.changePassword": "Change password",
     "profile.cut-offdate": "Billing cut-off date",
     "profile.billinghistory": "Billing history",
     "profile.save": "Save",
     "profile.informationwill": "Payment information will appear in your accountave",
     "profile.maytake": "may take a few days after the billing cut-off date.",
     "profile.paymentdate": "payment date",

     /* 12.basic_information */
     "basic_information.fillinbasic": "Fill in the basic information to get started",
     "basic_information.displayname": "ชื่อที่ใช้แสดงในระบบ",
     "basic_information.fillingin": "Filling in information will allow us to design an",
     "basic_information.anexercise": "exercise program that is better suited for you.",
     "basic_information.gender": "Gender",
     "basic_information.male": "Male",
     "basic_information.female": "Female",
     "basic_information.age": "Age",
     "basic_information.weight": "Weight",
     "basic_information.height": "Height",
     "basic_information.youaresure": "You are sure that you can practice difficult exercises correctly such as squatting or Jumping.?",
     "basic_information.sure": "Sure",
     "basic_information.unsure": "Not Sure",
     "basic_information.createExercise": "Create an exercise program",
     "basic_information.selectunit": "select unit",
     "basic_information.year": "year",

      /* 13.challenge */
      "challenge.allMission": "All Mission",
      "challenge.teamlist": "Team list",
      "challenge.teamscoreboard": "Team scoreboard",
      "challenge.friendlist": "Friend list",
      "challenge.rules": "Rules",
      "challenge.nameyourteam": "Name your team",
      "challenge.6alphabet": "Name your team more than 6 alphabet",
      "challenge.teamsystem": "The name is already used",
      "challenge.confirmationname": "Naming confirmation",
      "challenge.notNameyourteam": "You don’t have a team",
      "challenge.allteamsfull": "The system cannot randomly enter the team. Because every team has full members. Please create a new team or wait until a new team is created and try again.",
      "challenge.createyourteam": "Create your team",
      "challenge.randomteam": "Random team",
      "challenge.invitefriends": "Friend request",
      "challenge.addedfriends": "Added friends",
      "challenge.sendrequest": "send request",
      "challenge.notfriendssystem": "The user not found",
      "challenge.notfriends": "You don’t have friends",
      "challenge.howincreasefriends": "How to add friends",
      "challenge.points": "Points",
      "challenge.points2": "Points per Person",
      "challenge.singleChallenge": "Single Challenge",
      "challenge.teamChallenge": "Team Challenge",
      "challenge.inviteteam": "Invite friends to join your team",
      "challenge.sendinvitation": "Send an invitation",
      "challenge.eavingteam": "Do you want to leave the team?",
      "challenge.Leaveteam": "Leave the team",
      "challenge.pointsdetails": "Score details",
      "challenge.confirmdeletion": "Confirm friend deletion",
      "challenge.remove": "Do you want to remove",
      "challenge.fromfriend": "from your friend list?",
      "challenge.deletion": "friend deletion",
      "challenge.friendsRequest": "Friend’s request",
      "challenge.yourfriend": "wants to be your friend.",
      "challenge.refuse": "Refuse",
      "challenge.accept": "Accepted",
      "challenge.canstart": "• You can start adding 1 friend.",
      "challenge.activeweek": "• If you do 1 active week, you can add 2more friends.",
      "challenge.maximum": "• The maximum number of friends you can have is 15.",
      "challenge.emilfriend": "Your Friend’s email on Bebe Stayfit",
      "challenge.teampoint": "Team Scores",
      "challenge.teamsingle": "My Scores",
      "challenge.pointfriend": "Friend Scores",
      "challenge.completeweighing": "The team weigh completed",
      "challenge.time": "time",
      "challenge.weigh2": "Weighting 2 times per week",
      "challenge.completeweighing7": "The team weighted in for 7 days",
      "challenge.weightloss": "Weight loss from last week",
      "challenge.4days": "Completed 4 days exercise",
      "challenge.resetSunday": "*The list will be reset every Sunday",
      "challenge.scoresSunday": "*Scores are summarized every Sunday",
      "challenge.join": "Join",
      "challenge.joinChallenge": "Invitation to join the Challenge team",
      "challenge.wouldlike": "would like to invite you to join the team.",
      "challenge.10point": "Will receive 10",
      "challenge.weighed2times": "Weighted 2 times",
      "challenge.exercise4days": "Completed 4 days exercise per week",
      "challenge.allmembers": "All team members weighted 2 times",
      "challenge.teamreceive": "The whole team will receive",
      "challenge.eachDay": "At least one member weighs each day",
      "challenge.7day": "- Complete 7 days",
      "challenge.6day": "- Complete 6 days",
      "challenge.5day": "- Complete 5 days",
      "challenge.4day": "- Complete 4 days",
      "challenge.3day": "- Complete 3 days",
      "challenge.2day": "- Complete 2 days",
      "challenge.1day": "- Complete 1 day",
      "challenge.thatweek": "If that week",
      "challenge.extrapoints": "You will get extra points",
      "challenge.updatepoints": "The system will update the score every Sunday at 00:00",
      "challenge.teammembers": "Team Members",
     "challenge.10members": "There will be 10 members in 1 team, the system will automatically arrange the team. If the membership expires before the end of the season, it will be eliminated from the group in 7 days.",
     "challenge.upRank": "Ranking",
     "challenge.dividedinto": "The tier will be divided into New bronze silver Gold and Platinum. Each week, if the total score is more than 40 points will be romoted. Scores less than or equal to 40 points will be downgraded by 1 order. The system will update the score every Sunday at midnight.",
     "challenge.collectingpoints": "Collecting points",
     "challenge.individualpoints": "Individual points",
     "challenge.areearned": "are earned through missions, the number of points earned depends on the weekly force. The higher the rank, the higher the score. Team points will be the total accumulated points of the members. If a team member completes a task, the team member will also earn points.",
     "challenge.season": "Season reward details",
     "challenge.trackedFacebook": "Track the rewards via Facebook Group",
     "challenge.friend": "Friend",
     "challenge.person": "Person",
     "challenge.team": "Team",
     "challenge.number": "Team Members",
     "challenge.friendRequest": "Modeejungz Young There is no mission because it is not during the challenge period.",
     "challenge.addFriend": "Add friend",
     "challenge.pending": "Pending",
     "challenge.cancelRequest": "Cancel request",
     "challenge.find": "Find",
     "challenge.addedtoYourFriends": "Added to Your Friends",
     "challenge.name_email": "Your friends’ registered name or email with Bebe Stay Fit",
     "challenge.activeUsers": "Active Users",
     "challenge.noResultsFound": "No results found.",

      /* 14.cancel_package_new */
      "cancel_package_new.unsubscribe": "Unsubscribe",
      "cancel_package_new.bebeStayFit": "Bebe Stay Fit",
      "cancel_package_new.yourPackage": "Your package",
      "cancel_package_new.basedOnProgramDuration": "(based on program duration)",
      "cancel_package_new.onceTheSubscription": "*Once the subscription is cancelled, the system will automatically stop charging.",
      "cancel_package_new.pleaseTellUsTheReaso": "Please tell us the reason you cancelled your membership. We appreciate any feedbacks to improve our products and services",
      "cancel_package_new.pleaseSpecify_1": "Please specify",
      "cancel_package_new.pleaseSpecify_2": "Please specify",
      "cancel_package_new.finishCancellation": "Finish Cancellation",
      "cancel_package_new.month": "month",
      "cancel_package_new.yourSubscription": "Your subscription with Bebe Stay Fit has been cancelled.",
      "cancel_package_new.thankYouForTrusting": "Thank you for trusting us with your fitness journey. We are always here to support your health and fitness goals.",
      "cancel_package_new.backProfile": "Back to your profile",
      "cancel_package_new.midnight": "8 am. - midnight (Daily)",
      "cancel_package_new.phone": "Phone",
      "cancel_package_new.monFri": "9 am. - 6pm.(Mon-Fri)",
      "cancel_package_new.with": "(with@)",
      "cancel_package_new.contactOurStaff": "Contact our staff",
      "cancel_package_new.get5": "Get 5% discount",
      "cancel_package_new.continuingYour": "for continuing your subscription with Bebe Stay Fit",
      "cancel_package_new.close": "Close",
      "cancel_package_new.contactOurStaffTo": "Contact our staff to customise",
      "cancel_package_new.yourExercise": "your exercise program",
      "cancel_package_new.likeOurProduct": "If you like our product but find it difficult to exercise, please contact our staff for extra support.",
      "cancel_package_new.contactUs": "Contact us",
      "cancel_package_new.cancelSubscription": "Cancel Subscription",
      "cancel_package_new.onsultOurSpecialists": "Consult our specialists to",
      "cancel_package_new.customMake": "custom-make your exercise program.",
      "cancel_package_new.youAreNotSeeing": "You are not seeing results from working out? Don’t give up just yet. It takes time to get your dream body. Be strong!",
      "cancel_package_new.youAreNotSeeingWorking": "You are not seeing results from working out? Don’t give up just yet. It takes time to get your dream body. Be strong!",
      "cancel_package_new.contactStaffToCustomise": "Contact our staff to customise",
      "cancel_package_new.exerciseProgram": "your exercise program",
      "cancel_package_new.ifYouLikeOurProduct": "If you like our product but find it difficult to exercise, please contact our staff for extra support.",
      "cancel_package_new.alwaysKeep": "Always keep your diet and health on track to maintain your dream body and well-being.",
      "cancel_package_new.ultimate4day": "You can achieve your dream body with our ultimate 4-day split workout routines!Cheer up!",
      "cancel_package_new.ourWorkoutProgram": "Our workout program may be a bit tough when getting started, but please stick to it and you will get stronger and better! Your dream body is not as far away as you might think. Go, girl!",
      "cancel_package_new.imIn": "I’m in!",
    },
    locale: 'en-US',
    data: appLocaleData
};
export default EnLang;